import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController ,LoadingController, ModalController} from 'ionic-angular';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { CompaniasProvider } from '../../providers/companias/companias'
import { Storage } from '@ionic/storage'
import { reorderArray } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service'
import { ProductosEditarPage } from '../../pages/productos-editar/productos-editar'
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-reservas-sin-asignar',
  templateUrl: 'reservas-sin-asignar.html',
  providers: [ AuthService ]
})
export class ReservasSinAsignarPage {
  listaProductos = [];
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId
  listaReservas
  tiposReservasId: any;
  listaProductosSeleccionados
  allItems
  buscar:string =''
  realizandoUnaVenta:boolean= true
  queHago:boolean = true
  loader
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio: ProductosPorGruposProvider,
              public servicioCompania:CompaniasProvider,
              private storage: Storage,
              public alertControllers:AlertController,
              public auth: AuthService,
              public loadingCtrl:LoadingController,
              public modalControllers: ModalController,
              public utils: UtilsProvider) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
    .then((val)=>{
      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']

      }
    })
    this.buscarDatos()
  }

  buscarDatos(){
    this.storage.get('companiasId').then((val) => {
      this.companiasId = val
    this.servicio.buscarTiposReservasNoControlaPrecio(val)
    .subscribe(
      res => {
        this.listaReservas = !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
      },
      err => {
      }
    )

    this.servicio.buscarTodosLosProductosPorReservasSinAsignar(val)
    .subscribe(
      (res: any) => {
        this.listaProductosSeleccionados =  !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
      },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )



  })

  }


  reorderItems(indexes) {
    this.listaProductos = reorderArray(this.listaProductos, indexes);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductosPorGruposDragPage');
  }

  agregarAlCarrito(item) {

        if(this.tiposReservasId===undefined){
          this.mostrarMensajeAdvertencia('Debe seleccionar un valor en el campo tipo reservas')
          return
        }

        let tiposReservasSinAsignarIdIdbuscar = item['productosElaboradosId']

        let contarProductosConElMismoId = this.listaProductos.filter(
            item => item.productoId === tiposReservasSinAsignarIdIdbuscar )
        if(contarProductosConElMismoId.length > 0){
            // el producto ya existe en el carrito
            return
        }
        // el producto aun no ha sido agregado
        this.listaProductos.push(item)
        this.buscar = ''
        this.getItems(this.buscar)
        this.realizandoUnaVenta = true
      }

      onEvent(event: string, item: any){

        if (event === 'onTextChange') {

         let valor = this.getItems(this.buscar);
         if(valor){
              item = valor
        }
        }
        }

        getItems(event: any): void {
          if(!this.allItems){
            let valores = this.listaProductosSeleccionados
            this.allItems = valores;
          }
            this.listaProductosSeleccionados = this.allItems.filter((item) => {
              return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
            });
      }

      cerrarSession(){
        this.auth.logout()
        this.navCtrl.setRoot('LoginPage');
      }

      guardar(){

        this.realizandoUnaVenta = false
        if(this.listaProductos.length>0){
          if(this.tiposReservasId===undefined){
              this.mostrarMensajeAdvertencia('Debe seleccionar un tipo reserva')
              this.buscar = ''
              this.getItems(this.buscar)
              this.realizandoUnaVenta = true
          }else{
            let idgrupo = this.buscarUuidGrupos()
            let tiposReservasId = idgrupo[0].tiposReservasId

            let listaProductosJson: any = this.listaProductos.map((items: any, index: number) => {
              return {
                  companiasId: items.companiasId,
                  tiposReservasId:   Number(tiposReservasId),
                  gruposReservasPorProductoId: Number(items.gruposReservasPorProductoId)
                  }

            })
            let listaProductosJsonResponse = listaProductosJson.filter((item)=> item !== undefined)
            for(let i=0;i<listaProductosJsonResponse.length;i++){
            this.servicio.almacenarVariosRegistrosReservasSinAsignar(
              listaProductosJsonResponse[i].companiasId,
              listaProductosJsonResponse[i].gruposReservasPorProductoId,
              listaProductosJsonResponse[i].tiposReservasId)
            .subscribe(
              res => {
                if(i + 1 === listaProductosJsonResponse.length) {
                  this.utils.mensajeMuestro('Reserva sin asignar','Actualizado Exitosamente!','success')
                }
              },
              err => {
                if(i + 1 === listaProductosJsonResponse.length) {
                  this.utils.mensajeMuestro('Reserva sin asignar','No se pudo actualizar el registro, intente luego','warning')
                }
              }
            )
            }
                      }
        }else{
          let alert = this.alertControllers.create({
            title: 'Advertencia',
            subTitle: 'Debe seleccionar un tipo reserva, verifique',
            buttons: ['Cerrar']
          });
          alert.present();
        }
        this.limpiar()
      }


      buscarUuidGrupos(){

        let data = []
        let valorComparar = Number(this.tiposReservasId)
        for(let k=0;k< this.listaReservas.length;k++){
          if(k === valorComparar){

            data.push({
              tiposReservasId : this.listaReservas[k].tiposReservasId
            })
            k = this.listaReservas.length + 1
          }
        }

        return data

      }

      limpiar(){
        this.listaProductos = []
        this.realizandoUnaVenta = true
        this.tiposReservasId = undefined
        this.buscar=''
      }
      mostrarMensajeDeError(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      mostrarMensajeAdvertencia(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Advertencia',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }


      mostrarMensajeExito(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Registro exitoso',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      procesarResultado() {
        this.limpiar()
        this.buscarDatos()
      }

      buscarporCompania(item:any){
        let idgrupo = this.buscarUuidGrupos()
        let tiposReservasId = idgrupo[0].tiposReservasId
        this.storage.get('companiasId').then((val)=>{
          let idgrupo = Number(tiposReservasId)
          this.servicio.buscarReservasSinAsignarDrag(val,idgrupo)
            .subscribe((data)=>{
              this.listaProductos = !NUBE_AWS ? data : JSON.parse(data['_body']).data[0]
            },(error)=>{
              console.log(error)
            })
        })

      }
      eliminarValor(item:any,i:any){
        console.log(item,i)
      }

      eliminarRegistro(item,i){

        if(item.productosPorGruposId!==0){

          this.servicio.eliminarReservasSinasignar(item)
          .subscribe((data)=>{
           this.listaProductos.splice(i,1)
          },(error)=>{
            console.log(error)
          })
        }else{
          this.listaProductos.splice(i,1)
        }


      }

}



// WEBPACK FOOTER //
// ./src/pages/reservas-sin-asignar/reservas-sin-asignar.ts